import React from "react";
import { BaseRecord, useTranslate } from "@refinedev/core";
import { DateField, DeleteButton } from "@refinedev/antd";
import { Button, Space, Table, Upload, UploadProps } from "antd";
import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import Column from "antd/es/table/Column";
import { GlassCard, ActionButton } from "../../../shared/components";

type AccountInvoiceListProps = {
  record: any;
  uploadProps: UploadProps;
  downloadingInvoiceId: number | null;
  onDownloadInvoice: (invoiceId: number) => void;
  onInvoiceDeleted: () => void;
};

export const AccountInvoiceList: React.FC<AccountInvoiceListProps> = ({
  record,
  uploadProps,
  downloadingInvoiceId,
  onDownloadInvoice,
  onInvoiceDeleted,
}) => {
  const _t = useTranslate();

  return (
    <div>
      <div className="flex items-center justify-end mb-6">
        <Upload {...uploadProps}>
          <ActionButton variant="primary">
            <UploadOutlined />
            {_t('invoices.titles.create')}
          </ActionButton>
        </Upload>
      </div>
      <GlassCard className="!p-0 overflow-hidden">
        <Table dataSource={record?.invoices} rowKey="id" size="small">
          <Column
            title={_t("invoices.fields.createdAt")}
            dataIndex="createdAt"
            render={(value: any) => <DateField value={value} format="DD/MM/YYYY HH:mm" />}
            width={180}
          />
          <Table.Column
            title={_t("invoices.fields.totalInclVat")}
            dataIndex="totalInclTax"
            render={(value: any) => `${(value / 100).toFixed(0)} €`}
          />
          <Table.Column
            title={_t("table.actions")}
            dataIndex="actions"
            render={(_: any, invoice: BaseRecord) => (
              <Space>
                <Button
                  type="primary"
                  icon={<DownloadOutlined />}
                  loading={downloadingInvoiceId === invoice.id}
                  onClick={() => onDownloadInvoice(invoice.id as number)}
                >
                  {_t('invoices.titles.download')}
                </Button>
                <DeleteButton
                  resource="invoices"
                  recordItemId={invoice.id}
                  onSuccess={onInvoiceDeleted}
                >
                  {_t('invoices.titles.delete')}
                </DeleteButton>
              </Space>
            )}
          />
        </Table>
      </GlassCard>
    </div>
  );
};
